/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable react/jsx-pascal-case */
import TawkMessengerReact from '@tawk.to/tawk-messenger-react';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { BrowserRouter, Route, Switch } from "react-router-dom";
import Login from './components/authentication/Login';
import MyProfile from './components/authentication/MyProfile';
import Register from './components/authentication/Register';
import PortfolioDetails from './components/pageComponents/portfolio/PortfolioDetails';
import PricingDetails from './components/pageComponents/pricing/PricingDetails';
import DashboardAddBlog from './dashboard/blogs/DashboardAddBlog';
import DashboardAllBlog from './dashboard/blogs/DashboardAllBlog';
import Dashboard_message from './dashboard/messages/Dashboard_messages';
import DashboardOrder from './dashboard/orders/DashboardOrders';
import DashboardAddPortfolio from './dashboard/portfolio/DashboardAddPortfolio';
import DashboardAllPortfolio from './dashboard/portfolio/DashboardAllPortfolio';
import DashboardAddPricing from './dashboard/pricing/DashboardAddPricing';
import DashboardAllPricing from './dashboard/pricing/DashboardAllPricing';
import DashboardAddResume from './dashboard/resume/DashboardAddResume';
import Dashboard_users from './dashboard/users/Dashboard_users';
import Dashboard from './dashboard/utils/Dashboard';
import AdminRoute from './faetures/AdminRoute';
import Back from './faetures/BackToTop';
import Notfound from './faetures/Notfound';
import ProtectRoute from './faetures/ProtectRoute';
import ScrollToTop from './faetures/ScrollToTop';
import Loader from './faetures/Spinner';
import About from './pages/About';
import Blog from './pages/Blog';
import BlogDetails from './pages/BlogDetails';
import Contact from './pages/Contact';
import Home from './pages/Home';
import Portfolio from './pages/Portfolio';
import Pricing from './pages/Pricing';
import PrivecyAndPolicy from './pages/PrivecyAndPolicy';
import Service from './pages/Services';
import { allBlogsForRecent } from './redux/actions/frontendActions/blogActions';
import { userView } from './redux/actions/frontendActions/viewerAction';
const App = () => {
  const  dispatch =useDispatch();
  // const [isLoading, setIsloading] = useState(false);
  const { recentPost } = useSelector(
    (state) => state.Blog
  );
  useEffect(() => {
    dispatch(userView())

    dispatch(allBlogsForRecent());

  }, []);


  // useEffect(() => {
  //     setIsloading(true)
  //     setTimeout(() => {
  //             setIsloading(false)
  //     }, 4000)
  // },[])
  useEffect(() => {
    const handleContextmenu = e => {
        e.preventDefault()
    }
    document.addEventListener('contextmenu', handleContextmenu)
    return function cleanup() {
        document.removeEventListener('contextmenu', handleContextmenu)
    }
}, [ ])
  return (
    <>
      {
        recentPost.length === 0 ? <Loader/> :
        <BrowserRouter>
      <Back/>
      <ScrollToTop/>

      <TawkMessengerReact
propertyId="63861d5db0d6371309d1bc6a"
widgetId="1gj1u5els"/>


        <Switch>
            <Route path='/' component={Home} exact/>
            <Route path='/about-me' component={About} exact/>
            <Route path='/service' component={Service} exact/>
            <Route path='/pricing' component={Pricing} exact/>
            <Route path='/price/:id' component={PricingDetails} exact/>
            <Route path='/blogs/:currentPage?' component={Blog} exact/>
            <Route path='/blog/:id' component={BlogDetails} exact/>
            <Route path='/portfolio/:currentPage?' component={Portfolio} exact/>
            <Route path='/portfoliodata/:id' component={ PortfolioDetails} exact/>
            <Route path='/register' component={Register} exact/>
            <Route path='/login' component={Login} exact/>
            <Route path='/contact' component={Contact} exact/>
            <Route path='/policy' component={PrivecyAndPolicy} exact/>
            <ProtectRoute path='/myProfile' component={MyProfile} exact/>
               <AdminRoute path='/admin/dashboard' component={Dashboard} exact />
               <AdminRoute path="/admin/dashboard/add-portfolio" component={DashboardAddPortfolio} exact/>
               <AdminRoute path="/admin/dashboard/all-portfolio/:currentPage?" component={DashboardAllPortfolio} exact />
               <AdminRoute path="/admin/dashboard/add-blog" component={DashboardAddBlog } exact  />
               <AdminRoute path="/admin/dashboard/all-blog/:currentPage?" component={DashboardAllBlog}  exact/>
               <AdminRoute path="/admin/dashboard/add-pricing" component={DashboardAddPricing } exact />
               <AdminRoute path="/admin/dashboard/all-pricing/:currentPage?" component={DashboardAllPricing} exact />
               <AdminRoute path="/admin/dashboard/all-orders/:currentPage?" component={DashboardOrder} exact />
               <AdminRoute path="/admin/dashboard/all-users/:currentPage?" component={Dashboard_users} exact />
               <AdminRoute path="/admin/dashboard/all-messages/:currentPage?" component={ Dashboard_message} exact /> 
               <AdminRoute path="/admin/dashboard/add-resume" component={ DashboardAddResume} exact /> 
               <AdminRoute path="*" component={ Notfound} exact /> 
        </Switch>
      </BrowserRouter>



      }


    </>
  );
};

export default App;

